<h1 ev-dialog-title data-testid="info-dialog-title">{{ title }}</h1>

<div ev-dialog-content class="scrollable" data-testid="info-dialog-container">
  <div class="info-content">
    @if (message) {
      <app-modal-option-panel>
        <p class="info-message" data-testid="info-dialog-message-text" [innerHtml]="message"></p>
      </app-modal-option-panel>
    }
  </div>
</div>

<div ev-dialog-actions>
  <button class="ev-button primary" mat-button data-testid="info-dialog-ok-btn" (click)="cancel()">{{ button }}</button>
</div>
